import { Component, type ReactNode } from 'react'
import { Button, Result } from 'antd'
import { RefreshCw, AlertTriangle } from 'lucide-react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  public override state: State = {
    hasError: false,
    error: null,
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  public override componentDidCatch(error: Error, errorInfo: any) {
    console.error('[ErrorBoundary caught error]', error, errorInfo)
  }

  private handleReset = () => {
    this.setState({ hasError: false, error: null })
    window.location.reload()
  }

  public override render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            padding: 24,
          }}
        >
          <Result
            status="error"
            icon={<AlertTriangle size={48} color="#ff3e4d" />}
            title={<span style={{ color: '#f6f6f9' }}>页面渲染发生异常</span>}
            subTitle={
              <span style={{ color: '#9fa2b8' }}>
                {this.state.error?.message || '未知错误，请重试或联系系统管理员。'}
              </span>
            }
            extra={[
              <Button
                type="primary"
                key="reload"
                icon={<RefreshCw size={16} />}
                onClick={this.handleReset}
              >
                刷新页面
              </Button>,
            ]}
          />
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
